var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4915_13441)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7249 12.3086C17.5849 12.3086 16.5149 12.5386 15.6149 12.9286C18.7649 13.8386 20.9949 16.0186 21.0549 18.5686C22.6949 18.3586 24.4649 17.7386 24.4649 16.0486C24.4649 14.0186 21.8349 12.3086 18.7249 12.3086Z",
    fill: "#FFBE0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6949 10.8687H18.7149C20.8449 10.8687 22.5849 9.12867 22.5849 7.00867C22.5849 4.87867 20.8449 3.13867 18.7149 3.13867C18.2949 3.13867 17.8949 3.20867 17.5149 3.32867C18.2049 4.34867 18.6049 5.57867 18.6049 6.90867C18.6149 8.25867 18.1949 9.55867 17.4049 10.6387C17.8149 10.7887 18.2449 10.8687 18.6949 10.8687Z",
    fill: "#FFBE0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87491 12.9186C7.97491 12.5386 6.90491 12.3086 5.77491 12.3086C2.66491 12.3086 0.0349121 14.0186 0.0349121 16.0486C0.0349121 17.7386 1.79491 18.3486 3.43491 18.5686C3.48491 16.0186 5.71491 13.8386 8.87491 12.9186Z",
    fill: "#FFBE0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77492 10.8687H5.80492C6.25492 10.8687 6.68492 10.7887 7.09492 10.6387C6.33492 9.59867 5.88492 8.30867 5.88492 6.90867C5.88492 5.57867 6.28492 4.34867 6.97492 3.32867C6.59492 3.20867 6.19492 3.13867 5.77492 3.13867C3.64492 3.13867 1.91492 4.87867 1.91492 7.00867C1.91492 9.12867 3.64492 10.8687 5.77492 10.8687Z",
    fill: "#FFBE0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2445 13.9453C8.28352 13.9453 4.93652 16.1013 4.93652 18.6533C4.93652 21.9533 10.4365 21.9533 12.2445 21.9533C15.3825 21.9533 19.5545 21.6133 19.5545 18.6743C19.5545 16.1103 16.2065 13.9453 12.2445 13.9453Z",
    fill: "#FFBE0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2456 11.7743H12.2786C13.5736 11.7703 14.7896 11.2613 15.7016 10.3423C16.6146 9.42339 17.1146 8.20439 17.1096 6.91139C17.1096 4.22839 14.9286 2.04639 12.2456 2.04639C9.56357 2.04639 7.38257 4.22839 7.38257 6.91139C7.38257 9.59239 9.56357 11.7743 12.2456 11.7743Z",
    fill: "#FFBE0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4915_13441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.d4f90eac77289d0f06be3338392e1d96.svg";
export { ForwardRef as ReactComponent };